import React from 'react';

/**
 * DatePickerField component that supports partial dates
 * Accepts: DD.MM.YYYY (full date), MM.YYYY (month+year), or YYYY (year only)
 * Updated: Support for partial date entry
 * 
 * @param {Object} props - Component props
 * @param {string} props.label - Label for the field
 * @param {string} props.value - Current value (DD.MM.YYYY, MM.YYYY, or YYYY)
 * @param {function} props.onChange - Callback when value changes
 * @param {string} props.error - Error message to display
 * @param {string} props.placeholder - Placeholder text (default: "DD.MM.YYYY")
 * @param {string} props.testId - Test ID for testing
 * @param {string} props.id - HTML ID attribute
 * @param {string} props.name - HTML name attribute
 */
const DatePickerField = ({ 
  label, 
  value, 
  onChange, 
  error, 
  placeholder = "DD.MM.YYYY",
  testId,
  id,
  name
}) => {
  // Handle manual text input
  const handleTextInput = (event) => {
    const inputValue = event.target.value;
    
    // Allow only numbers and dots
    const sanitized = inputValue.replace(/[^0-9.]/g, '');
    
    // Update the value directly for typing experience
    onChange(sanitized);
  };

  return (
    <div>
      <label className="block text-sm font-semibold text-gray-700 mb-3">
        {label}
      </label>
      <div className="relative">
        <input
          type="text"
          id={id}
          name={name}
          value={value || ''}
          onChange={handleTextInput}
          placeholder={placeholder}
          data-testid={testId}
          className={`block w-full pl-12 pr-4 py-4 text-lg border ${
            error ? 'border-red-500' : 'border-gray-300'
          } rounded-xl focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent transition-all duration-200`}
        />
        <div className="absolute left-0 top-0 h-full pl-4 flex items-center pointer-events-none">
          <i className="fas fa-calendar-alt text-gray-400"></i>
        </div>
      </div>
      {error && (
        <p className="mt-2 ml-3 text-sm text-red-600">{error}</p>
      )}
    </div>
  );
};

export default DatePickerField;
